import type { EventType } from '@hopin-team/api-hopin/@types';
import React from 'react';

import { useLocales } from '../../hooks';
import { GenericTag } from '../EventPartTag';
import { hybridTagStyling } from './item-styles';

export const FormatTags = ({ eventType }: { eventType: EventType }) => {
  const { t } = useLocales('event');
  const tags = eventType === 'hybrid' ? ['virtual', 'onsite'] : [eventType];

  return (
    <>
      {tags.map(type => (
        <GenericTag
          key={type}
          label={t(type)}
          testId={`${type}-pill`}
          styling={hybridTagStyling}
        />
      ))}
    </>
  );
};
